<template>
  <chart-card title="Cadastros" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-integer />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    cadastros: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.cadastros.map((object) => object.data)],
        datasets: [
          {
            label: 'Cadastros',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.cadastros.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubeClientesCadastradosChart: 'clientes-cadastrados',
    }),

    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.clubeClientesCadastradosChart({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.cadastros = helpers.agrupamentoMensal(data, 'NUM_CLIENTES_CADASTRADOS')
          })
        }

        if (this.filterType === 'semanal') {
          await this.clubeClientesCadastradosChart({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.cadastros = helpers.agrupamentoSemanal(data, 'NUM_CLIENTES_CADASTRADOS')
          })
        }

        if (this.filterType === 'diario') {
          await this.clubeClientesCadastradosChart({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.cadastros = helpers.agrupamentoDiario(data, 'NUM_CLIENTES_CADASTRADOS')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
